import log from "loglevel";
import React, { useState, useEffect, useReducer, useRef, useCallback } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import ManualMarksTemplate from "../../../../../../../Navigation/Course/Content/Programming/Instructor/AllSubmissions/ManualMarksTemplate";
import "primeflex/primeflex.css";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import {
  Breadcrumb,
  // Dropdown,
  // DropdownButton,
  Form,
  // ProgressBar,
  Spinner,
  Button,
  Container
} from "react-bootstrap";
import * as constants from "Constants";
import httpService from 'services/httpService.js';
import displayGlobalMessage, { toastConfig } from "Utils/DisplayGlobalMessage";
import { RiDeleteBinLine } from "react-icons/ri";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from 'primereact/paginator';
import { VscRunAll } from "react-icons/vsc";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { SlRefresh } from "react-icons/sl";

import "primeflex/primeflex.css";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import { toast } from "react-toastify";

const DEFAULT_MAX_ROWS_PER_REQUEST = 20;

const SearchBox = ({ handleSearchChange, lazyLoading }) => {

  const debounceSearchRefTimerId = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    clearTimeout(debounceSearchRefTimerId.current);
    debounceSearchRefTimerId.current = setTimeout(() => handleSearchChange(event), 500);
  }

  return (
    <div>
      <Form.Control
        type="search"
        value={searchQuery}
        style={{ height: 30 }}
        onChange={handleSearch}
        placeholder="Search"
        disabled={lazyLoading}
      />
    </div>
  );
}

const ForceRunSubmissions = () => {

  const target = useRef(null);
  const { activityID } = useParams()
  const [loading, setLoading] = useState(false);

  const forceRunSubmissions = useCallback(async () => {
    let toastId = "";
    try {
      setLoading(true);
      toastId = toast.loading(
        `This process may take some time. Please avoid reloading this page to keep track of the status. If you reload the page, the status won't appear. The 'Total Submissions' count will update on each refresh if the Force Run running. At the end, 'Total Submissions' will be equal to 'Total Students'`,
        toastConfig
      );
      const url = `${constants.base_url}/otherlabs/activity/${activityID}/force_run_submissions/`;
      const response = await httpService.post(url);
      const data = response.data;
      // displayGlobalMessage(
      //   `New Submissions Created = ${data?.new_submissions_created || 0} | Old Submissions Updated = ${data?.old_submissions_updated}`,
      //   "success"
      // );
      toast.update(toastId, {
        // render: `New Submissions Created = ${data?.new_submissions_created || 0} | Old Submissions Updated = ${data?.old_submissions_updated}`,
        render: `Force run operation succesfull.`,
        type: "success",
        ...toastConfig,
        isLoading: false
      });
    } catch (err) {
      log.error(err);
      displayGlobalMessage("Error Occurred", "error");
      toast.update(toastId, {
        render: "Error Occurred",
        type: "error",
        ...toastConfig,
        isLoading: false
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {
        loading ?
          "Running now, it may take some time. Please stay on this page" :
          "Forcefully run the submissions for all the students."
      }
    </Tooltip>
  );


  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <Button
        variant='outline-primary'
        size="sm"
        onClick={() => forceRunSubmissions()}
        disabled={loading}
        className="d-flex justify-content-center align-items-center gap-2"
        ref={target}
      >
        {loading ? <Spinner animation="border" size="sm" /> : <></>}
        <VscRunAll size={20} />
        Force Run
      </Button >
    </OverlayTrigger>
  )
}

const HeaderComponent = ({ submissionsSummary, handleDownload, downloadAllLabFiles, handleSearchChange, lazyLoading, className }) => {

  const { activityID } = useParams()
  const [_submissionsSummary, _setSubmissionsSummary] = useState(submissionsSummary);
  const [isSummaryLoading, setIsSummaryLoading] = useState(false);

  const fetchSubmissionsSummary = useCallback(async (noSucessFeedback = false) => {
    setIsSummaryLoading(true);
    setTimeout(async () => {
      const base_other_activity_submissions_url = `${constants.base_url}/otherlabs/activity/${activityID}/other_activity_submissions`
      const submission_summary_url = `${base_other_activity_submissions_url}/summary/`;
      const response = await fetch(submission_summary_url);
      if (!response.ok) {
        displayGlobalMessage('Failed to refresh summary!', 'error');
      }
      const data = await response.json();
      _setSubmissionsSummary(data);
      if (!noSucessFeedback) {
        displayGlobalMessage('Refreshed', 'success');
      }
      setIsSummaryLoading(false);
    }, 500)
  }, []);

  useEffect(() => {
    fetchSubmissionsSummary(true);
  }, [fetchSubmissionsSummary]);


  return (
    <div
      className={`d-flex justify-content-between align-items-center ${className}`}
    >
      <div className="d-flex flex-wrap">
        <div style={{ marginRight: "20px" }}>
          <span style={{ fontWeight: "bold" }}>Total students:</span>{" "}
          <Button
            style={{
              border: "none",
              cursor: "default",
              padding: "0.2rem 0.5rem",
              borderRadius: "0.25rem",
            }}
            disabled
            variant='outline-primary'
          >
            {_submissionsSummary["total_students"]}
          </Button>
        </div>
        <div style={{ marginRight: "20px" }}>
          <span style={{ fontWeight: "bold" }}>Total submissions:</span>{" "}
          <Button
            style={{
              border: "none",
              cursor: "default",
              padding: "0.2rem 0.5rem",
              borderRadius: "0.25rem",
            }}
            disabled
            variant='outline-primary'
          >
            {_submissionsSummary["total_submissions"]}
          </Button>
        </div>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip id="button-tooltip">
            Refresh summary
          </Tooltip>}
        >
          <Button
            variant='outline-primary'
            size="sm"
            onClick={() => fetchSubmissionsSummary()}
            disabled={isSummaryLoading}
            className="d-flex justify-content-center align-items-center gap-2"
          >
            <SlRefresh className={isSummaryLoading ? 'spin' : ''} />
          </Button >
        </OverlayTrigger>
      </div>
      <div className="d-flex justify-content-end align-items-center">
        <div style={{ marginRight: '10px' }}>
          <ForceRunSubmissions />
        </div>
        <div style={{ marginRight: '10px' }}>
          <Button variant='outline-primary' size="sm" onClick={handleDownload}>
            Download Marks
          </Button>
        </div>
        <div style={{ marginRight: '10px' }}>
          <Button variant='outline-primary' size="sm" onClick={downloadAllLabFiles}>
            Download All Files
          </Button>
        </div>
        <SearchBox handleSearchChange={handleSearchChange} lazyLoading={lazyLoading} />
      </div>
    </div>
  );
};

function ViewSubmissions() {
  const location = useLocation();
  const { activityID, courseId, labId } = useParams();
  log.log({ ViewSubmissions: { activityID, courseId, labId } });

  log.log("location state : ", location.state)
  const [labTitle, setLabTitle] = useState(location.labTitle);
  const [activityTitle, setActivityTitle] = useState("");

  const [lazyLoading, setLazyLoading] = useState(false);
  const [sortField, setSortField] = useState(sessionStorage.getItem("sortField") || "email");
  const [sortOrder, setSortOrder] = useState(sessionStorage.getItem("sortOrder") || "1");
  const [querySortOrder, setQuerySortOrder] = useState(sessionStorage.getItem("querySortOrder") || "");
  const [searchQuery, setSearchQuery] = useState(""); //Used for filtering
  const [submissionsSummary, setSubmissionsSummary] = useState({});

  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  //Used for selecting the columns which are to be displayed in the submissions page
  const [isAllChecked, setIsAllChecked] = useState(sessionStorage.getItem("isAllChecked") === "true" || false);
  const [isRollnoVisible, setIsRollnoVisible] = useState(sessionStorage.getItem("isRollnoVisible") === "true" || false);
  const [isTAVisible, setIsTAVisible] = useState(sessionStorage.getItem("isTAVisible") === "true" || false);

  const [allSubmissionsData, setAllSubmissionsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [QuizData, setQuizData] = useState(null);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [first, setFirst] = useState(0);
  const [maxRowsPerRequest, setMaxRowsPerRequest] = useState(DEFAULT_MAX_ROWS_PER_REQUEST)
  const [rows, setRows] = useState(DEFAULT_MAX_ROWS_PER_REQUEST);
  const [totalCount, setTotalCount] = useState(DEFAULT_MAX_ROWS_PER_REQUEST);

  useEffect(() => {
    setRows(maxRowsPerRequest);
  }, [maxRowsPerRequest]);

  const onPageChange = (one, two) => {
    log.log(one);
    setCurrentPageNumber(one.page + 1);
    setRows(one.rows);
    setFirst(one.first);
  }

  const fetchData = useCallback(async () => {
    try {
      const base_other_activity_submissions_url = `${constants.base_url}/otherlabs/activity/${activityID}/other_activity_submissions`
      let submissions_url = `${base_other_activity_submissions_url}/?page=${currentPageNumber}&page_size=${DEFAULT_MAX_ROWS_PER_REQUEST}`;

      if (searchQuery) {
        submissions_url = `${submissions_url}&search_query=${searchQuery}`
      }
      if (sortField) {
        submissions_url = `${submissions_url}&sort=${querySortOrder}${sortField}`
      }

      // Set lazy loading to true
      setLazyLoading(true);

      // if (!submissionsSummary || Object.keys(submissionsSummary || {}).length === 0) {
      //   const submission_summary_url = `${base_other_activity_submissions_url}/summary/`;
      //   const response = await fetch(submission_summary_url);
      //   if (!response.ok) {
      //     throw new Error("Couldn't fetch summary, response returned was not ok.");
      //   }
      //   const data = await response.json();
      //   setSubmissionsSummary(data);
      // }

      const response = await fetch(submissions_url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const jsonData = await response.json();
      log.log("jsonData ", jsonData);
      if (jsonData) {
        setTotalCount(!isNaN(jsonData.total_count) ? jsonData.total_count : DEFAULT_MAX_ROWS_PER_REQUEST)
        setAllSubmissionsData(jsonData.data);
        setIsLoading(false); // Data has been fetched, so set loading to false
      }
      if (!QuizData) {
        let url = constants.base_url + "/lab/activity/";
        url = url + activityID + "?type=other";
        const resp = await httpService.get(url);
        setQuizData(resp.data);
        setLabTitle(resp.data?.other_activity?.lab_data?.title);
        setActivityTitle(resp.data?.other_activity?.name)

        log.log("quiz response data", resp.data)

        localStorage.setItem('quiz_data', JSON.stringify(resp.data?.other_activity));
        log.log("data stud ", jsonData?.data)
        localStorage.setItem('student_quiz_data', JSON.stringify(jsonData.data));
      }
    } catch (error) {
      log.error('Error fetching data:', error);
      displayGlobalMessage('Error Fetching data.', "error");
    } finally {
      setLazyLoading(false);
      setIsLoading(false);
    }
  }, [location, searchQuery, querySortOrder, sortField, currentPageNumber])

  useEffect(() => {
    fetchData();
  }, [querySortOrder, sortField, currentPageNumber, searchQuery]);

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setIsAllChecked(isChecked);
    setIsRollnoVisible(isChecked);
    setIsTAVisible(isChecked);
  };

  // This function is used to handle the individual checkboxes
  const handleIndividualCheckboxChange = (checkboxName, isChecked) => {
    switch (checkboxName) {
      case "rollNo":
        setIsRollnoVisible(isChecked);
        break;
      case "ta":
        setIsTAVisible(isChecked);
        break;
      default:
        break;
    }
  };

  // This function is used to handle the search query
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const manualMarksTemplate = (rowData) => {
    const updateTotalMarks = (totalMarks) => {
      rowData.total_marks = totalMarks;
    };
    if (rowData?.submission_status !== "Not Uploaded")
      return (
        <ManualMarksTemplate
          rowData={rowData}
          updateSubmission={updateSubmission}
          updateTotalMarks={updateTotalMarks}
          disabled={true}
        />
      );
    else return <div></div>;
  };

  const updateSubmission = async (rowData, id, manual_marks, comments) => {
    const form_data = new FormData();
    form_data.append("obtained_manual_marks", manual_marks);
    form_data.append("comments", comments);
    const url = constants.base_url + "/evalpro/manual_marks/" + id;
  
    try {
      const response = await httpService.put(url, form_data);
      forceUpdate();
    } catch (error) {
      log.error(error);
    }
  };

  const TableHeader = () => {
    return (
      <div className="flex justify-content-between align-items-center">
        <Form style={{ marginLeft: "8px" }}>
          <Form.Check
            inline
            type="switch"
            id="selectAllCheckbox"
            label="Select All"
            checked={isAllChecked}
            onChange={(e) => handleSelectAll(e)}
            style={{ marginRight: "15px" }}
          />
          <Form.Check
            inline
            type="checkbox"
            id="rollNoCheckbox"
            label="Roll no"
            checked={isRollnoVisible}
            onChange={() =>
              handleIndividualCheckboxChange("rollNo", !isRollnoVisible)
            }
            style={{ marginRight: "15px" }}
          />
          <Form.Check
            inline
            type="checkbox"
            id="taCheckbox"
            label="TA"
            checked={isTAVisible}
            onChange={() => handleIndividualCheckboxChange("ta", !isTAVisible)}
            style={{ marginRight: "15px" }}
          />
        </Form>
      </div>
    );
  };

  // Function to prepare CSV data from tableData
  const prepareCsvData = () => {
    // Extract necessary data from tableData
    let tableData = allSubmissionsData;
    const csvRows = tableData.map((row, index) => {
      return [
        index + 1, // Sno
        row.email,
        row.first_name,
        row.obtained_manual_marks
      ].join(',');
    });

    // Add header row
    const headerRow = ['S.No.', 'Email', 'Name', 'Marks'].join(',');
    csvRows.unshift(headerRow);

    // Combine rows into CSV data
    const csvData = csvRows.join('\n');
    return csvData;
  };

  // Function to handle download button click
  const handleDownload = () => {
    log.log('download started');
    const csvData = prepareCsvData();
    log.log('csv header processed')
    const blob = new Blob([csvData], { type: 'text/csv' });

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'submission_data.csv';

    // Trigger download
    link.click();

    // Release the object URL
    window.URL.revokeObjectURL(url);
    log.log('downloaded !!!!');
  };

  const handleViewSubmissions = (rowData) => {
    const { email } = rowData; // Extracting the email field from the rowData object
    log.log('Viewing submissions for email:', email);
    log.log("quiz data", QuizData);
    let studentSubmissionUrl = `${location.pathname}/${email}`;
    const state = {
      email: email,
      data: rowData,
    };
    window.open(studentSubmissionUrl, '_blank');
    // Here you can implement the logic to display the submissions for the provided email address
  };

  const deleteSubmission = async (rowData) => {
    log.log({ rowData, QuizData });

    const confirmDelete = window.confirm("Are you sure you want to delete this submission?");

    log.log({ confirmDelete });

    if (!confirmDelete) return;

    try {
      let url = constants.base_url + "/otherlabs/activity/" + activityID + `/student_submission/?student_id=${rowData.email}`;
      const response = await httpService.delete(url);
      log.log("response ", response);
      if (response.data?.msg) {
        displayGlobalMessage(response.data.msg, "success");
      }
      fetchData();
    } catch (err) {
      log.error(err);
      if (err?.response?.data?.msg) {
        displayGlobalMessage(err.response.data.msg, "error");
      } else {
        displayGlobalMessage(err?.toString?.() || "Something went wrong", "error");
      }
    }
  };

  const downloadLabFiles = useCallback(async (data) => {
    try {
      log.log({ data });
      let _url = constants.base_url + "/otherlabs/activity/";
      let downloadFilesUrl = _url + data['lab_id'] + "/other_submission_download_lab_files?stud_id=" + encodeURIComponent(data['student_id']) + "&username=" + encodeURIComponent(data['first_name']);
      const response = await httpService.get(downloadFilesUrl, { responseType: 'blob' });

      let filename = `${data['student_id']}_lab_${data['lab_id']}_files_.tar.gz`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      log.error('Error downloading the file:', error.response);
      if (error?.response?.headers?.['content-type']?.includes?.('application/json')) {
        // The response is JSON, so parse it as text and then convert to JSON
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        log.log({ json });
        if (json.error_title && json.error_desc) {
          let message = <><b>{json.error_title}</b><p className="mb-0">{json.error_desc}</p></>
          displayGlobalMessage(message, "error");
        } else {
          displayGlobalMessage('Failed to download the file.', 'error');
        }
      } else {
        displayGlobalMessage('Failed to download the file.', 'error');
      }
    }
  });

  const downloadAllLabFiles = useCallback(async () => {
    try {
      let url_ = location.pathname;
      let urlArray = url_.split("/");
      let activityID = urlArray[9];
      let _url = constants.base_url + "/otherlabs/activity/";
      let downloadFilesUrl = _url + activityID + "/other_submission_download_lab_files_all_students/";

      const response = await httpService.get(downloadFilesUrl, {
        responseType: 'blob'
      });

      let filename = `${activityID}_lab_files_submitted.tar.gz`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      log.error('Error downloading the file:', error.response);
      if (error?.response?.headers?.['content-type']?.includes?.('application/json')) {
        // The response is JSON, so parse it as text and then convert to JSON
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        log.log({ json });
        if (json.error_title && json.error_desc) {
          let message = <><b>{json.error_title}</b><p className="mb-0">{json.error_desc}</p></>
          displayGlobalMessage(message, "error");
        } else {
          displayGlobalMessage('Failed to download the file.', 'error');
        }
      } else {
        displayGlobalMessage('Failed to download the file.', 'error');
      }
    }
  });

  const handleSort = (event) => {
    log.log({ event })
    setSortField(event.sortField ? event.sortField : "");
    setSortOrder(event.sortOrder);
    if (event.sortOrder === -1) {
      setQuerySortOrder("-");
    } else {
      setQuerySortOrder("");
    }
  };

  const columns = [
    // {
    //   selectionMode: "multiple",
    //   headerStyle: { width: "3rem" },
    //   frozen: true,
    // },
    {
      headerStyle: { width: "3rem" },
      header: "S.No.",
      frozen: true,
      body: (data, options) => ((options.rowIndex + 1) + (currentPageNumber - 1) * DEFAULT_MAX_ROWS_PER_REQUEST),
    },
    {
      field: "email",
      header: "Email",
      frozen: true,
      sortable: true,
      style: { width: "250px" },
    },
    {
      field: "first_name",
      header: "Name",
      sortable: true,
      style: { width: "100px" },
    },
    {
      field: "roll_no",
      header: "Roll No",
      sortable: false,
      hidden: !isRollnoVisible,
      style: { width: "100px" },
    },
    {
      field: "TA",
      header: "TA",
      sortable: false,
      hidden: !isTAVisible,
      style: { width: "100px" },
    },
    {
      field: "obtained_manual_marks",
      header: "Marks",
      sortable: true,
      style: { width: "120px" },
      // body: manualMarksTemplate,
    },
    {
      field: "total_marks",
      header: "Total Marks",
      sortable: false,
      style: { width: "120px" },
    },
    {
      field: "submission_status",
      header: "Submission Status",
      sortable: false,
      style: { width: "150px" },
    },
    {
      header: "Download Files",
      body: (data) => (
        <Button variant='outline-primary' size="sm" onClick={() => downloadLabFiles(data)}>Download Files</Button>
      ),
      style: { width: "150px" }, // Adjust width as needed
    },
    {
      header: "View Submission",
      body: (data) => (
        <Button variant='outline-primary' size="sm" onClick={() => handleViewSubmissions(data)}>View Submission</Button>
      ),
      style: { width: "150px" }, // Adjust width as needed
    },
    {
      header: "Delete Submission",
      body: (data) => (
        <Button variant="outline-danger" size="sm" onClick={() => deleteSubmission(data)}>
          <RiDeleteBinLine />
        </Button>
      ),
      style: { width: "150px" }, // Adjust width as needed
    },
  ];

  return (
    <div>
      <div className="cont">
        {/* <Navbar navbarClass="navbar-dark fixed-top" /> */}
        <Breadcrumb>
          <Breadcrumb.Item
          // href={`/courseware/course/${courseId}/content/labs`}
          >
            <Link to={`/courseware/course/${courseId}/content/labs`}>
              Labs
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item
          // href={`/courseware/course/${courseId}/content/labs/${labId}/`}
          >
            <Link to={`/courseware/course/${courseId}/content/labs/${labId}/`}>
              {labTitle}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item
          // href={`/courseware/course/${courseId}/content/labs/${labId}/other/${activityID}`}
          >
            <Link to={`/courseware/course/${courseId}/content/labs/${labId}/other/${activityID}`}>
              {activityTitle}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Submissions</Breadcrumb.Item>
        </Breadcrumb>

        <HeaderComponent
          className="mx-2 mb-3"
          downloadAllLabFiles={downloadAllLabFiles}
          handleDownload={handleDownload}
          handleSearchChange={handleSearchChange}
          lazyLoading={lazyLoading || isLoading}
          submissionsSummary={submissionsSummary}
        />
        <div>
          {isLoading ? (
            <Container className="d-flex justify-content-center align-items-center">
              <Spinner size="sm" animation="border" />
            </Container>
          ) : (
            <>
              <DataTable style={{ position: 'relative' }}
                value={allSubmissionsData}
                header={<TableHeader />}
                lazy={true}
                scrollHeight="68vh"
                removableSort
                onSort={handleSort}
                sortField={sortField}
                sortOrder={sortOrder}
                stripedRows={false}
                showGridlines={false}
                columnResizeMode="expand"
                // onSelectionChange={(e) =>
                //   setSelectedSubmissions
                //     ? setSelectedSubmissions(e.value)
                //     : setClickedRow(e.value)
                // }
                // onAllRowsSelect={(e) => {
                //   setIsSelectAllChecked(true);
                //   setTimeout(() => setSelectedSubmissions(allSubmissionsData), 300);
                // }}
                // onAllRowsUnselect={() => {
                //   setIsSelectAllChecked(false);
                //   setSelectedSubmissions([]);
                // }}
                loading={lazyLoading}
              >
                {
                  columns.map((column, index) => (
                    <Column
                      field={column.field}
                      header={column.header}
                      frozen={column.frozen}
                      sortable={column.sortable}
                      style={column.style}
                      body={column.body}
                      expander={column.expander}
                      selectionMode={column.selectionMode}
                      headerStyle={column.headerStyle}
                      hidden={column.hidden}
                    />
                  ))
                }
              </DataTable>
              <Paginator
                className="my-2"
                style={{ position: "absolute", bottom: -12, width: "100%", transform: 'scale(0.8)' }}
                first={first}
                rows={rows}
                totalRecords={totalCount}
                onPageChange={onPageChange}
              // rowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ViewSubmissions;